import React from 'react';
import classes from './SelectedSalesOrder.module.css';
import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import moment from 'moment';
import { useTranslation } from '../../../hooks/useTranslations';

export const CustomerProfileTab: React.FC<{ selectedSalesOrder: SalesOrderInfo }> = ({
  selectedSalesOrder,
}) => {
  const lang = localStorage.getItem('lang') || 'en';
  const { translations } = useTranslation();
  return (
    <div className={classes.tabContentSection}>
      <div className={classes.tabHeader}>
        {translations('customer.information')}
        <div className={classes.tabSubheader}>
          {translations('basic.info')}
          {translations('ecocare.platform')}
        </div>
      </div>
      <div className={classes.tabContentSectionHeader}>{translations('personal')}</div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('full.name')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.person_firstname}{' '}
          {selectedSalesOrder.customer_person.person_lastname}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('email')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.person_email}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('phone.number')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.person_mobile_phone}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('date.of.birth')}</div>
        <div className={classes.customerProfileRowText2}>
          {moment(selectedSalesOrder.customer_person.person_birthdate)
            .locale(lang)
            .format('DD.MM.YYYY')}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('gender')}</div>
        <div className={classes.customerProfileRowText2}>{selectedSalesOrder.gender.gender}</div>
      </div>
      <div className={classes.tabContentSectionHeader}>
        {translations('additional.informations')}
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('height')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.height} cm
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('weight')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.weight} kg
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('blood.type')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.blood_type}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>
          {translations('label_relationship_status')}
        </div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.relation_status}
        </div>
      </div>
    </div>
  );
};
